/* import __COLOCATED_TEMPLATE__ from './color-popover-editor.hbs.js'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { scheduleOnce } from '@ember/runloop';
import { CALLOUT_BLOCK_BACKGROUND_COLORS, CALLOUT_BLOCK_BORDER_COLORS } from '@intercom/composer-ember/lib/blocks/constants';
import { columnResizingPluginKey } from 'prosemirror-tables';
const defaultValue = 'default';
let ColorPopoverEditor = (_class = class ColorPopoverEditor extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "wasResizing", false);
  }
  get composer() {
    return this.args.composer;
  }
  get addDefault() {
    return defaultValue;
  }
  get currentRect() {
    let currentlyActiveBlock = this.currentlyActiveBlock;
    if (!currentlyActiveBlock) {
      return new DOMRect(0, 0, 0, 0);
    }
    let activeBlockDomElement = this.composer.findDomAtDocumentPosition(currentlyActiveBlock.start).node;
    if (!activeBlockDomElement) {
      return new DOMRect(0, 0, 0, 0);
    }
    return activeBlockDomElement.getBoundingClientRect();
  }
  get currentlyActiveBlock() {
    if (this.composer.state.selectionIsTableCell) {
      return this.composer.state.currentlyActiveTableCell;
    }
    return this.composer.state.currentlyActiveCallout;
  }
  get isVisible() {
    return this.composer.state.isInteractive && this.composer.state.selectionInfo.visible && (this.composer.state.selectionIsInCallout || this.canColorTableCell);
  }
  get canColorTableCell() {
    let columnResizeState = columnResizingPluginKey.getState(this.composer.state.prosemirrorState);
    let isDraggingResizeHandle = Boolean(columnResizeState?.dragging);
    this.handleResizeStateChange(isDraggingResizeHandle);
    return this.composer.state.selectionIsTableCell && !isDraggingResizeHandle;
  }
  handleResizeStateChange(isDragging) {
    if (this.wasResizing === isDragging) {
      return;
    }
    let editorElement = this.composer.state.editorView?.dom;
    if (!editorElement) {
      return;
    }
    if (isDragging) {
      this.wasResizing = true;
      editorElement.classList.add('is-resizing-column');
    } else {
      this.wasResizing = false;
      editorElement.classList.remove('is-resizing-column');
      if (this.composer.state.selectionIsTableCell) {
        scheduleOnce('afterRender', this, this.clearCellSelection);
      }
    }
  }
  clearCellSelection() {
    if (!this.composer.state.selectionIsTableCell) {
      return;
    }
    let {
      selection
    } = this.composer.state.prosemirrorState;
    let cellPos = selection.$from.pos;
    this.composer.commands.setSelection(cellPos, cellPos);
  }
  updateColor(color) {
    if (this.composer.state.selectionIsTableCell) {
      this.composer.commands.styling.updateTableCellBackgroundColor(CALLOUT_BLOCK_BACKGROUND_COLORS[color]);
      this.clearCellSelection();
    } else {
      this.composer.commands.styling.updateCalloutColor({
        backgroundColor: CALLOUT_BLOCK_BACKGROUND_COLORS[color],
        borderColor: CALLOUT_BLOCK_BORDER_COLORS[color]
      });
    }
    this.composer.commands.focus();
  }
}, _applyDecoratedDescriptor(_class.prototype, "updateColor", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateColor"), _class.prototype), _class);
export { ColorPopoverEditor as default };